<template>
  <div class="min-h-screen flex items-center justify-center px-6">
    <div class="max-w-md rounded-3xl border border-white/10 bg-midnight-900/80 p-6 text-sm text-steel-300">
      <p class="text-xs uppercase tracking-[0.3em] text-steel-500">Auth</p>
      <p class="mt-3 text-white">{{ statusMessage }}</p>
      <p v-if="errorMessage" class="mt-3 text-rose-200">{{ errorMessage }}</p>
    </div>
  </div>
</template>

<script>
import { supabase } from '@/lib/supabase'

export default {
  name: 'AuthCallback',
  data() {
    return {
      statusMessage: 'Processing sign-in…',
      errorMessage: '',
    }
  },
  async mounted() {
    try {
      if (window.__drvnAuthProcessing) {
        this.statusMessage = 'Finalizing sign-in…'
        return
      }
      window.__drvnAuthProcessing = true

      const hasCode = window.location.search.includes('code=')
      if (hasCode && typeof supabase.auth.exchangeCodeForSession === 'function') {
        let exchangeError = null
        try {
          const { error } = await supabase.auth.exchangeCodeForSession(window.location.href)
          exchangeError = error || null
        } catch (err) {
          exchangeError = err
        }
        if (exchangeError?.name === 'AbortError') {
          // Retry once if the request was aborted by a duplicate caller.
          await new Promise((resolve) => setTimeout(resolve, 200))
          const { error } = await supabase.auth.exchangeCodeForSession(window.location.href)
          exchangeError = error || null
        }
        if (exchangeError) {
          console.error('Error exchanging code for session:', exchangeError)
          this.errorMessage = exchangeError.message || 'Unable to complete sign-in.'
          return
        }
        const { data } = await supabase.auth.getSession()
        if (data?.session) {
          this.statusMessage = 'Sign-in complete. Redirecting…'
          window.location.replace('/feed')
          return
        }
        this.errorMessage = 'Session not available yet. Please try again.'
        return
      }
      const { data } = await supabase.auth.getSession()
      if (data?.session) {
        this.statusMessage = 'Sign-in complete. Redirecting…'
        window.location.replace('/feed')
        return
      }
      this.errorMessage = 'Missing sign-in code. Try again.'
    } catch (err) {
      console.error(err)
      this.errorMessage = 'Unexpected error during sign-in.'
      return
    } finally {
      window.__drvnAuthProcessing = false
      const clean = window.location.origin + window.location.pathname
      window.history.replaceState({}, document.title, clean)
    }
  },
}
</script>
